import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSubPermissionArray } from "../redux/actions/apiAction/userPermissions/userPermissionsActions";
import { verifiedRoutePermissions } from "../utility/utils";
import { history } from "./AppRouter";

export default function PermissionManagement({ ...rest }) {
  const dispatch = useDispatch();
  const userPermissions = useSelector(
    (state) => state.userPermissions.userPermissions
  );
  const isSuperAdmin = useSelector(
    (state) => state.userPermissions.isSuperAdmin
  );

  async function handleUserPermissions() {
    if (userPermissions && userPermissions.length) {
      const defaultRoute = userPermissions.find(
        (item) => item.isAccess && !item.path.includes("/:id")
      );
      const routePermissions = verifiedRoutePermissions(
        userPermissions,
        rest.path,
        isSuperAdmin
      );

      if (!isSuperAdmin && !routePermissions) {
        return history.push(defaultRoute.path);
      }
      if (!isSuperAdmin) {
        dispatch(
          setSubPermissionArray(
            (routePermissions && routePermissions.subPermission) || {}
          )
        );
      } else {
        let subPermission = {};
        if (routePermissions) {
          for (const key in routePermissions.subPermission) {
            subPermission[key] = true;
          }
        }
        dispatch(setSubPermissionArray(subPermission));
      }
    }
  }

  useEffect(() => {
    handleUserPermissions();
  }, [userPermissions, isSuperAdmin, rest.path]);

  return <></>;
}
